import React from "react";
import { Avatar, Chip, Grid, MenuItem, Typography } from "@mui/material";
import initCapitalize from "../../../../utils/commonFunctions/initCapitalize";

interface BeneficaryItemsProps {
	items: {
		name: string;
		percentage: string;
		relationship: string;
		type: string;
	}[];
}

const BeneficiaryMenuItems: React.FC<BeneficaryItemsProps> = ({ items }) => {
	return (
		<>
			{items.map((item, index) => (
				<MenuItem key={index}>
					<Grid container alignItems="center" spacing={1}>
						<Grid item>
							<Avatar sx={{ width: 24, height: 24 }}>{item.name[0]}</Avatar>
						</Grid>
						<Grid item xs>
							<Typography variant="body2" noWrap>
								{item.name}
							</Typography>
						</Grid>
						<Grid item>
							<Chip
								label={item.type === null ? "N/A" : initCapitalize(item.relationship)}
								size="small"
								sx={{
									backgroundColor: "green",
									color: "white",
									marginRight: "10px",
									fontSize: "0.75rem",
									height: 20
								}}
							/>
						</Grid>
						<Grid item xs>
							<Typography variant="body2" noWrap>
								{item.type}
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body2">{item.percentage}</Typography>
						</Grid>
					</Grid>
				</MenuItem>
			))}
		</>
	);
};

export default BeneficiaryMenuItems;
